import * as angular from "angular";

angular
  .module('bringoz.admin.planning')
  .constant('Planning_Projects_Process_Tracking_PN', {
    database: 'processTracking',
    isBranchEntity: false,
    events: {
      onCreate: 'created',
      onChange: 'changed'
    }
  });
